function isPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var flag = true;
    for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

//更改根字体的fontsize方法
function adapter(base){
    const dip = document.documentElement.clientWidth;
    const rootFontSize = dip / base;
    document.documentElement.style.fontSize = rootFontSize + 'px'
}

//如果是pc设备更改根字体的fontsize
if(isPC()){
    document.documentElement.style.fontSize = '37.5px'
    window.onresize = ()=>{
        document.documentElement.style.fontSize = '37.5px'
    }
}
